module.exports = __webpack_public_path__ + "icons/dustbinRed.f7d04631bcac2d057aea014d4f127302.svg";